import { useEffect, useState } from "react";

import Input from "Components/Global/Form/Input";

import Checkboxes from "../Checkboxes";

const Question = ({ question, answers, setAnswers, isSponsor }) => {
  const [answer, setAnswer] = useState(answers || []);

  useEffect(() => {
    if (!answer?.length || !answer) return;

    setAnswers((prev) => ({ ...prev, [question?.id]: answer }));
  }, [answer]);

  if (question?.type === "text")
    return (
      <Input
        key={question?.id}
        name={`answer[${question?.id}]`}
        label={question?.text}
        placeholder="Digite aqui"
        type="textarea"
        height="200px"
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        disabled={isSponsor}
      />
    );

  return (
    <Checkboxes
      key={question?.id}
      label={question?.text}
      items={
        question?.options.map((option) => ({
          name: option?.id,
          label: option.text,
        })) || []
      }
      selected={answer}
      setSelected={setAnswer}
      disabled={isSponsor}
    />
  );
};

export default Question;
